import { type MaybeRefOrGetter } from 'vue';
import { viewListMaxTime } from '@store/itinerary';

interface Options {
    onTimeout: () => void;
    overrideCondition?: MaybeRefOrGetter<boolean>;
}

export default function useReload(options?: Options) {
    const { overrideCondition, onTimeout } = options || {};
    const timeoutShown = ref(false);
    const lastShowTime = ref<Date>();
    const interval = ref<number>();
    const checkCondition = () => {
        if (overrideCondition) {
            return toValue(overrideCondition);
        } else {
            return (
                dayConfig
                    .gregory()
                    .diff(dayConfig.gregory(lastShowTime.value)) >=
                viewListMaxTime
            );
        }
    };
    function start() {
        lastShowTime.value = new Date();
        interval.value = window.setInterval(async () => {
            if (checkCondition() && !timeoutShown.value) {
                timeoutShown.value = true;
                const { isConfirmed } = await swal({
                    text: 'زمان زیادی گذشته است و اطلاعات ممکن است به روز نباشد.',
                    icon: 'warning',
                    showConfirmButton: true,
                    confirmButtonText: 'به روز رسانی',
                    showCancelButton: true,
                    cancelButtonText: 'متوجه شدم',
                });
                if (isConfirmed) {
                    onTimeout?.();
                    timeoutShown.value = false;
                    lastShowTime.value = new Date();
                }
            }
        }, 1000);
    }

    function stop() {
        window.clearInterval(interval.value);
        interval.value = undefined;
    }

    function forceReset() {
        timeoutShown.value = false;
        lastShowTime.value = new Date();
    }

    return {
        start,
        stop,
        forceReset,
    };
}
